<template>
  <div class='w-full'>
    <div class='flex flex-row justify-between items-center mb-2'>
      <h2 class='text-gray-700 text-xl font-semibold'>
        Q&A ({{ commentsCount }})
      </h2>
      <button
        class='text-gray-700 text-xs font-semibold p-2 border border-gray-300 rounded-md'
        @click='showEnterNewComments = !showEnterNewComments'>
        {{ showEnterNewComments ? 'Hide' : 'Add Question' }}
      </button>
    </div>
    <comment-create-input v-if='showEnterNewComments' class='mb-4' />
    <div v-if='comments.length > 0'
      class='bg-white rounded-t-md'>
      <div v-for='(comment, index) in parentComments'
        :key='`comment-${index}`'
        class='px-2'>
        <comment-row :comment='comment' :session='session' />
      </div>
    </div>
    <div v-else class='bg-gray-100 p-8 rounded-md flex flex-col justify-center items-center'>
      <message-circle-icon class='mb-2 text-gray-500' size='24'/>
      <p class='text-gray-900 text-sm lg:text-base'>{{noQuestionsText}}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters }       from 'vuex'
import CommentCreateInput from '@/components/gbcc2025/PublicSessionCommentCreateInput.vue'
import CommentRow         from '@/components/gbcc2025/PublicSessionCommentRow.vue'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isSameOrAfter)
import { MessageCircleIcon } from 'vue-tabler-icons'

export default {
  name: 'PublicSessionComments',
  props: {
    comments: {
      type: Array,
      required: true
    },
    showMessageWhenNotLoggedIn: {
      type: Boolean,
      default: false
    },
    session: {
      type: Object,
      default: null,
    }
  },
  data () {
    return {
      showEnterNewComments: false,
    }
  },
  components: {
    CommentCreateInput,
    CommentRow,
    MessageCircleIcon,
  },
  computed: {
    ...mapGetters('users', [
      'isConferenceSpeaker',
      'isAdmin',
    ]),
    ...mapGetters('events', [
      'showTextInKorean',
    ]),
    commentsCount () {
      return this.comments.length
    },
    parentComments () {
      return this.comments.filter(comment => comment.parentCommentId == null)
    },
    noQuestionsText () {
      if (this.showTextInKorean) {
        return '등록된 질문이 없습니다.'
      } else {
        return 'No questions have been submitted yet.'
      }
    },
    sameOrAfterVideoScheduledStartDate () {
      return dayjs().tz('Asia/Seoul').isSameOrAfter(dayjs(this.session.scheduledStartTime).tz('Asia/Seoul'), 'date')
    },
    sameVideoScheduledStartDate () {
      return dayjs().tz('Asia/Seoul').isSame(dayjs(this.session.scheduledStartTime).tz('Asia/Seoul'), 'date')
    },
  },
}
</script>


